import { VenueEntity } from '../../../apis/venue/venue-entity';
import { inject } from 'aurelia';
import { Project } from '../../../model/project';
import { IRouter } from '@aurelia/router';
import { Message } from '../../../components/callout/message';
import { ProjectModelService } from '../../../services/project-model-service';
import { ScheduleEntity } from '../../../apis/schedule/schedule-entity';
import { ScheduleFieldEntity } from '../../../apis/schedule/schedule-field-entity';
import { GroupEntity } from '../../../apis/group/group-entity';
import { I18N } from '@aurelia/i18n';
import { ScheduleDisplayNameService } from '../../../services/schedule-display-name-service';

@inject(ProjectModelService, IRouter, I18N)
export class ManageVenues {

    public venues: VenueEntity[] = [];
    public venueRows: VenueRowViewModel[] = [];
    public messages: Message[] = [];

    public scheduleVenues: ScheduleVenuesViewModel[];
    private _project: Project;
    private _projectModelService: ProjectModelService;
    private _router: IRouter;
    private _i18n: I18N;
    constructor(projectService: ProjectModelService, router: IRouter, i18n: I18N) {
        this._projectModelService = projectService;
        this._router = router;
        this._i18n = i18n;
    }

    public async loading(params: any): Promise<void> {
        if (params.eventId != null) {
            this._project = await this._projectModelService.loadByEventId(params.eventId, false);
        } else {
            this._project = this._projectModelService.currentModel;
        }
        this.venues = this._project.venues;
        this.venueRows = this.venues.map(v => new VenueRowViewModel(v));
        this._updateModel();
    }

    public get venueNamePlaceholder(): string { return this._i18n.tr('ui:venue_name_placeholder'); }

    public get schedules(): ScheduleEntity[] {
        return this._project.schedules;
    }

    public get hasVenues(): boolean {
        return this.venues.any();
    }

    public addVenue(): void {
        const venue = this._projectModelService.addVenue('');
        const row = new VenueRowViewModel(venue);
        row.isEditing = true;
        this.venueRows.push(row);
        this.venues = this._project.venues;
    }

    public saveVenueName(row: VenueRowViewModel, name: string): void {
        this._projectModelService.updateVenue(row.venue.id, name);
        row.venue.name = name;
        row.isEditing = false;
        this._updateModel();
    }

    public deleteVenue(venue: VenueEntity): void {
        this.messages.clear();
        this._projectModelService.removeVenue(venue.id);
        this.venueRows = this.venueRows.filter(row => row.venue !== venue);
        this._updateModel();
    }


    public onVenueSelected(schedule: ScheduleVenuesViewModel, field: VenueFieldViewModel): void {
        this.messages.clear();
        const venueId = field.venueId === '' ? null : field.venueId;
        this._projectModelService.assignVenueToField(schedule.schedule.id, field.fieldId, venueId);
        this._updateModel();
    }

    public back(): void {
        void this._router.load(`create/event-summary/${this._project.event.id}`);
    }

    private _updateModel(): void {
        this.scheduleVenues = this.schedules.select(s => new ScheduleVenuesViewModel(s, this.venues, this._project.groups, this._projectModelService.getFieldsForSchedule(s.id)));
    }
}

export class VenueRowViewModel {
    public isEditing: boolean = false;

    constructor(public venue: VenueEntity) {}
}

export class ScheduleVenuesViewModel {
    public schedule: ScheduleEntity;
    private _groups: GroupEntity[];
    public fields: VenueFieldViewModel[];
    public get name(): string {
        return ScheduleDisplayNameService.getDisplayName(this.schedule, this._groups);
    }

    public venueId: string;

    public venues: VenueOptionViewModel[];
    constructor(schedule: ScheduleEntity, venues: VenueEntity[], groups: GroupEntity[], scheduleFields: ScheduleFieldEntity[]) {
        this.schedule = schedule;
        this._groups = groups;
        const fieldNumbers = schedule.games.select(g => g.fieldId).distinct<number>();
        this.fields = fieldNumbers.select(f => new VenueFieldViewModel(f, schedule.id, this.resolveVenue(scheduleFields, f)));
        this.venues = venues.select(v => new VenueOptionViewModel(v, this.fields));
    }

    public resolveVenue(scheduleFields: ScheduleFieldEntity[], fieldId: number): string {
        return scheduleFields.find(f => f.fieldNumber === fieldId)?.venueId ?? '';
    }
}

export class VenueFieldViewModel {
    public scheduleId: string;
    public fieldId: number = null;
    public venueId: string;

    constructor(fieldId: number, scheduleId: string, currentVenueId: string) {
        this.fieldId = fieldId;
        this.scheduleId = scheduleId;
        this.venueId = currentVenueId;
    }
}

export class VenueOptionViewModel {

    public venue: VenueEntity;
    private _venueFieldModels: VenueFieldViewModel[];
    public get taken(): boolean {
        return this._venueFieldModels.any(v => v.venueId === this.venueId);
    }

    public get venueId(): string {
        return this.venue.id;
    }

    public get name(): string {
        return this.venue.name;
    }

    constructor(venue: VenueEntity, venueFieldModels: VenueFieldViewModel[]) {
        this.venue = venue;
        this._venueFieldModels = venueFieldModels;

    }
}
